import styled from 'styled-components';
import { palette } from 'styled-tools';

export const Img = styled.img`
    width: inherit;
    height: inherit;
    object-fit: inherit;
    border: 1px solid ${palette('gray_opacity_200')};
    box-sizing: border-box;
    border-radius: 8px;
`;
